<template>
    <div style="padding:0 10px">

        <div v-for="(item,i) in content" :key="i">
        <a-icon type="notification" /> {{ item.title }}
    </div>
    </div>
</template>

<script>
     
    export default {
        name: "Notice",
        components: {
        },
        props: {
            content: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {

            }
        },

        methods: {

        },

        filters: {}

    };
</script>

<style scoped>

</style>